import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const savePromptVisibilitySelector = createSelector(
  selector,
  uiStore => get(uiStore, 'savePromptVisibility', false),
);

export const updatePopupVisibleSelector = createSelector(
  selector,
  store => store.updatePopupVisible,
);

export const removePopupVisibleSelector = createSelector(
  selector,
  store => store.removePopupVisible,
);
